import { render, staticRenderFns } from "./PrescriptionGoodsModal.vue?vue&type=template&id=3c044203&"
import script from "./PrescriptionGoodsModal.vue?vue&type=script&lang=js&"
export * from "./PrescriptionGoodsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports